import _get from 'lodash/get';
import _kebabCase from 'lodash/kebabCase';
import _capitalize from 'lodash/capitalize';
import { Google, Pixall } from '../analytics/index.js';
import { getInventoryOwnerById, isVDP } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
export async function inventoryVideoPlay(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    label: 'vid_ply',
    eventSource: 'vehicle',
    pageType: 'vdp',
    vehicleType: inventory?.listingType?.toUpperCase(),
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    }
  }, dataLayer, option);
  return {};
}
export async function inventoryVideoCompleted(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    label: 'vid_ply_cmpt',
    eventSource: 'vehicle',
    listingType: inventory?.listingType,
    pageType: 'vdp',
    pageid: 'fyc_vdp',
    vehicleType: inventory?.listingType?.toUpperCase(),
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    }
  }, dataLayer, option);
  return {};
}
export async function inventoryVideoMilestones(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state = {}
  } = metadata;
  const {
    inventoryId,
    milestone
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  if (milestone !== '100%') {
    Pixall.sendClickEvent({
      label: `vid_ply_${milestone?.replace('%', '')}`,
      eventSource: 'vehicle',
      listingType: inventory?.listingType,
      pageType: 'vdp',
      pageid: 'fyc_vdp',
      vehicleType: inventory?.listingType?.toUpperCase(),
      inventory,
      pixallData: {
        clickTypeToListingType: isVDP(dataLayer)
      }
    }, dataLayer, option);
  }
  return {};
}

/**
 * @summary Sends GA360 when clicking on images in Showcase
 */
export async function inventoryMediaViewerClick(metadata, option) {
  const {
    data = {},
    state = {},
    dataLayer = {}
  } = metadata;
  const {
    inventoryId,
    pixallTagLabel = '',
    isPsxVdp,
    placement = '',
    par = ''
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
  const inventoryData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  });
  const vehicleType = inventory?.type && inventory?.type.toUpperCase() || listingType?.toUpperCase();
  const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
  const isOverlayThumbnail = placement === 'thumbnail' && par === 'overlay';

  // Override some pixall data if is psx page
  const psxPixallData = {
    label: pixallTagLabel,
    listingType: 'pvt',
    pageId: 'fyc_psx_vdp',
    pixallData: {
      clickTypeToListingType: false
    }
  };

  // Dealer VDP always fire GA tag
  // PSX VDP only fire GA tag for 'View All Media' and thumbnail images inside Media Gallery modal
  if (!isPsxVdp || placement === 'view-all-media' || isOverlayThumbnail) {
    Google.sendClickEvent({
      eventElement: isPsxVdp ? 'private-seller' : `vdp_${listingType}`,
      eventResult: `cta::image::${placement}`,
      eventData: {
        vehicle: {
          ...inventoryData
        }
      }
    }, option);
  }

  // Dealer VDP only fire Pixall tag for "View All Media"
  // PSX VDP always fire Pixall tag except for the thumbnail images inside Media Gallery modal
  if (isPsxVdp && !isOverlayThumbnail || placement === 'view-all-media') {
    Pixall.sendClickEvent({
      label: `${pixallTagLabel} - ${pageId}`,
      eventSource: 'vehicle',
      vehicleType,
      pageType: 'vdp',
      inventory,
      pixallData: {
        clickTypeToListingType: isVDP(dataLayer)
      },
      ...(isPsxVdp && {
        ...psxPixallData
      })
    }, dataLayer, option);
  }
  return {};
}

/**
 * @summary Sends GA360 event when clicking on 'build offer' CTA on gallery overlay
 */
export function mediaGalleryNdsCTAClick(metadata, option) {
  const {
    data = {},
    state = {},
    dataLayer = {}
  } = metadata;
  const {
    inventoryId,
    label,
    location = 'top',
    ...rest
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory.listingType.toLowerCase() : '';
  const inventoryData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  });
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
  let pixallTagLabel;
  if (label === 'See Details') {
    if (location === 'bottom') {
      pixallTagLabel = 'see_dtl_btm';
    } else {
      pixallTagLabel = 'see_dtl_top';
    }
  } else {
    pixallTagLabel = 'calc_pymt_top';
  }
  Google.sendClickEvent({
    eventElement: isPrivateSeller ? 'private-seller' : `vdp_${listingType}`,
    eventResult: `cta::${_kebabCase(label)}::${location}`,
    eventData: {
      vehicle: {
        ...inventoryData
      }
    }
  }, option);
  Pixall.sendClickEvent({
    label: `${pixallTagLabel} - ${pageId}`,
    eventSource: 'vehicle',
    inventory,
    listingCode: inventory?.owner?.id,
    vehicleType: inventory?.listingType?.toUpperCase(),
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    ...(isPrivateSeller && {
      label: pixallTagLabel,
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp',
      pixallData: {
        clickTypeToListingType: false
      }
    })
  }, dataLayer, option);
  return {
    label,
    location,
    rest
  };
}

/**
 * @summary Sends GA360 when clicking on view all media link in full screen viewer
 */
export function viewAllMediaClick(_temp, option) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _temp === void 0 ? {} : _temp;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
  const inventoryData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  });
  Google.sendClickEvent({
    eventElement: `vdp_${listingType}`,
    eventResult: 'text-link::view-all-media',
    eventNonInteractive: false,
    eventData: {
      vehicle: {
        ...inventoryData
      }
    }
  }, option);
  return {};
}

/**
 * @summary Sends GA360 when clicking on media tab on overlay gallery
 */
export function mediaTabClick(_temp2, option) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _temp2 === void 0 ? {} : _temp2;
  const {
    inventoryId,
    pixallTagLabel = ''
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
  const vehicleType = inventory?.type && inventory?.type.toUpperCase() || listingType?.toUpperCase();
  const isPrivateSeller = inventory?.owner?.privateSeller;
  const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
  Pixall.sendClickEvent({
    label: `${pixallTagLabel}_tab_${pageId}`,
    eventSource: 'vehicle',
    vehicleType,
    pageType: 'vdp',
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    ...(isPrivateSeller && {
      label: `${pixallTagLabel}_tab`,
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp',
      pixallData: {
        clickTypeToListingType: false
      }
    })
  }, dataLayer, option);
  return {};
}
export function mediaVideoPhotoClick(_temp3, option) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _temp3 === void 0 ? {} : _temp3;
  const {
    inventoryId,
    pixallTagLabel = '',
    tagIndex
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
  const vehicleType = inventory?.type && inventory?.type.toUpperCase() || listingType?.toUpperCase();
  const isPrivateSeller = inventory?.owner?.privateSeller;
  Pixall.sendClickEvent({
    label: `${pixallTagLabel}`,
    eventSource: 'link',
    vehicleType,
    pageType: 'vdp',
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    ...(isPrivateSeller && {
      label: `${pixallTagLabel}`,
      listingType: 'pvt',
      pageId: 'fyc_psx_vdp',
      pixallData: {
        clickTypeToListingType: false
      }
    }),
    cdl: {
      eventProperties: {
        tagIndex
      }
    }
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends GA360 when clicking on prev/next arrows
 */
export function mediaViewerPagination(_temp4, option) {
  let {
    data = {},
    state = {},
    dataLayer = {}
  } = _temp4 === void 0 ? {} : _temp4;
  const {
    inventoryId,
    direction = 'next'
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const listingType = inventory?.listingType ? inventory?.listingType.toLowerCase() : (data?.listingType || '').toLowerCase();
  const inventoryData = googleInventoryTransformer(inventory, {
    target: 'vehicle',
    dataLayer
  });
  const isPrivateSeller = inventory?.owner?.privateSeller;
  Google.sendClickEvent({
    eventElement: isPrivateSeller ? 'private-seller' : `vdp_${listingType}`,
    eventResult: `cta::image::arrow-${direction}`,
    eventNonInteractive: false,
    eventData: {
      vehicle: {
        ...inventoryData
      }
    }
  }, option);
  return {};
}

/**
 * @summary Sends Pixall event when clicking on photo or video in media slider
 * @param {'photo'|'video'} metadata.data.element - Type of media element (photo or video only)
 */
export async function mediaSliderMediaClick(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId,
    element
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    label: `cta::${element}`,
    eventSource: 'vehicle',
    listingType: inventory?.listingType,
    listingCode: inventory?.owner?.id,
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    cdl: {
      eventProperties: {
        action: 'Click',
        element: _capitalize(element),
        intention: 'Open Media Gallery',
        tagIndex: element === 'photo' ? 'vdp-019' : 'vdp-020'
      }
    }
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Pixall event when clicking on Vehicle History Report link in media slider
 */
export async function mediaSliderVhrClick(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    label: 'ec_pa_txt-autocheck-Gallery',
    eventSource: 'vehicle-history-report',
    eventType: 'open',
    listingType: inventory?.listingType,
    listingCode: inventory?.owner?.id,
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    cdl: {
      eventProperties: {
        action: 'Click',
        element: 'Vehicle History Report Link',
        elementText: 'Vehicle History Report',
        location: 'Media Gallery',
        tagIndex: 'vdp-013',
        client: {
          name: 'AutoCheck',
          type: 'Vendor'
        },
        conversionGoal: 'Get Vehicle History Report',
        destinationDomain: 'www.autocheck.com',
        valueEventCode: 'A369'
      }
    }
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Pixall impression event when Vehicle History Report is shown in media slider
 */
export async function mediaSliderVhrImpression(metadata, option) {
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendImpression({
    dataLayer
  }, {
    label: 'vehicle-history-report::autocheckvhr::gallery',
    eventSource: 'vehicle-history-report',
    eventType: 'impression',
    goal: 'vehicle-history-report',
    listingType: inventory?.listingType,
    listingCode: inventory?.owner?.id,
    inventory,
    pixallData: {
      clickTypeToListingType: isVDP(dataLayer)
    },
    cdl: {
      eventProperties: {
        action: 'Impression',
        element: 'Vehicle History Report',
        location: 'Media Gallery',
        tagIndex: 'vdp-028',
        client: {
          name: 'AutoCheck',
          type: 'Vendor'
        }
      }
    }
  }, option);
  return {};
}
export default {
  inventoryMediaViewerClick,
  inventoryVideoPlay,
  inventoryVideoCompleted,
  inventoryVideoMilestones,
  viewAllMediaClick,
  mediaViewerPagination,
  mediaTabClick,
  mediaGalleryNdsCTAClick,
  mediaVideoPhotoClick,
  mediaSliderMediaClick,
  mediaSliderVhrClick,
  mediaSliderVhrImpression
};